export default "__VITE_ASSET__CDbRJbbn__"